import type { SVGProps } from 'react';
const SvgStickyNote2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#sticky_note_2_svg__a)">
      <path
        fill="currentColor"
        d="M19 3H4.99C3.89 3 3 3.9 3 5l.01 14c0 1.1.89 2 1.99 2h10l6-6V5c0-1.1-.9-2-2-2ZM7 8h10v2H7V8Zm5 6H7v-2h5v2Zm2 5.5V14h5.5L14 19.5Z"
      />
    </g>
    <defs>
      <clipPath id="sticky_note_2_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStickyNote2;
